import MainNavigation from "./MainNavigation";
import classes from "./Layout.modules.css";

function Layout({ children }) {
    return (
        <>
            <MainNavigation />
            <main>{children}</main>
        </>
    )
}
export default Layout;